export const tasksActionNames = {
  ADD_TASK: "ADD_TASK",
  SET_COMPLETE: "SET_COMPLETE",
  TOGGLE_BEING_EDITED: "TOGGLE_BEING_EDITED",
  EDIT_TASK: "EDIT_TASK",
};

export const addTask = (payload) => {
  return { type: tasksActionNames.ADD_TASK, payload: payload };
};

export const setComplete = (task) => {
  return { type: tasksActionNames.SET_COMPLETE, payload: task };
};

export const toggleBeingEdited = (task) => {
  return { type: tasksActionNames.TOGGLE_BEING_EDITED, payload: task };
};

export const editTask = (task) => {
  return { type: tasksActionNames.EDIT_TASK, payload: task };
};
